import styled, { CSSProperties } from 'styled-components';

export const VisibilityWrapper = styled.div<{
  $isVisible: boolean;
  $defaultDisplay?: CSSProperties['display'];
}>`
  display: ${({ $isVisible, $defaultDisplay }) =>
    $isVisible ? ($defaultDisplay ?? 'block') : 'none'};
`;
